import React from 'react';
import classNames from 'classnames';
import { useTranslation } from '@lt/localization';
import { getFormattedDuration } from 'src/utils/dateUtils';
import PlaneIcon from '@lt/components/icons-react/rebrand/Plane';
import {
  Direct as DirectIcon,
  Transition as TransitionIcon,
} from '@lt/components/icons-react/flights';

import styles from './flightDuration.module.css';

type Props = {
  value?: number;
  isMobile: boolean;
  direct: boolean;
};

const FlightDuration = (props: Props) => {
  const { t } = useTranslation();
  const { value: seconds, isMobile, direct } = props;
  const FLightIcon = direct ? DirectIcon : TransitionIcon;

  const titleAll = isMobile ? '' : t('commonPages.titleAll');
  const formattedDuration =
    seconds && getFormattedDuration(seconds, t('commonPages.distanceM'));

  const duration = seconds
    ? `${titleAll} ${formattedDuration}`
    : t('checkout.flight.emptytime.full_noData');

  return (
    <div className={styles.root}>
      <span className={styles.text}>{duration}</span>
      <div className={styles.iconWrapper}>
        <PlaneIcon className={styles.planeIcon} />
        <FLightIcon
          className={classNames({
            [styles.mobileFlightIcon]: isMobile,
            [styles.desktopDirectFlightIcon]: !isMobile && direct,
            [styles.desktopTransitionFlightIcon]: !isMobile && !direct,
          })}
        />
      </div>
    </div>
  );
};

export default FlightDuration;
